import type { DragLocationHistory } from '@atlaskit/pragmatic-drag-and-drop/types';
import {
	MAXIMUM_COLUMN_WIDTH,
	MINIMUM_COLUMN_WIDTH,
	MINIMUM_COLUMN_WIDTH_COMPACT,
	SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH,
} from '../../../../common/constants.tsx';

const CSS_RESIZING_WIDTH_PROPERTY = '--local-resizing-width';

export const setCssResizingWidth = (container: HTMLElement | null, width: number) => {
	container?.style.setProperty(CSS_RESIZING_WIDTH_PROPERTY, `${width}px`);
};
export const clearCssResizingWidth = (container: HTMLElement | null) => {
	container?.style.removeProperty(CSS_RESIZING_WIDTH_PROPERTY);
};

export const disableCssPointerEvents = (container: HTMLElement | null | undefined) => {
	container?.style.setProperty('pointer-events', 'none');
};
export const enableCssPointerEvents = (container: HTMLElement | null | undefined) => {
	container?.style.removeProperty('pointer-events');
};

export const ensureWidthWithinLimits = (
	width: number,
	isCompactColumnEnabled?: boolean,
	isSingleLineRowHeightEnabled?: boolean,
) => {
	const minColumnWidth = isSingleLineRowHeightEnabled
		? SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH
		: MINIMUM_COLUMN_WIDTH;
	return Math.min(
		Math.max(isCompactColumnEnabled ? MINIMUM_COLUMN_WIDTH_COMPACT : minColumnWidth, width),
		MAXIMUM_COLUMN_WIDTH,
	);
};

export const getProposedWidth = ({
	initialWidth,
	isCompactColumnEnabled,
	location,
	isSingleLineRowHeightEnabled,
}: {
	initialWidth: number;
	isCompactColumnEnabled?: boolean;
	location: DragLocationHistory;
	isSingleLineRowHeightEnabled?: boolean;
	columnType?: string;
}): number => {
	const diffX = location.current.input.clientX - location.initial.input.clientX;
	const proposedWidth = initialWidth + diffX;

	// ensure we don't go below the min allowed width
	return ensureWidthWithinLimits(
		proposedWidth,
		isCompactColumnEnabled,
		isSingleLineRowHeightEnabled,
	);
};
